import parseQueryParams from './get-query-params';

export const getPageId = () => {
  const { pageId } = parseQueryParams(window.location.search);
  return pageId;
};
